import { Bar, PolarArea } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import SoftBox from 'components/SoftBox';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);



const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
            display: false,
            position: 'top',
        },
        title: {
            display: false
        },
    },
    scales: {
        r: { // For the Y-axis
            max: 50
        }
    },
    animation: {
        duration: 10
    }

};

export default function PolarAreaChart({ data }) {


    // debugger;

    function getBackgroundColor(c) {
        console.log(c.raw)
        if (c.raw) {
            if (c.raw < 5) {
                return 'rgba(38, 124, 204, 1)'
            }
            else if (c.raw < 10) {
                return 'rgb(38, 124, 204)'
            }
            else if (c.raw < 15) {
                return 'rgb(131, 180, 226)'
            }
            else if (c.raw < 20) {
                return 'rgb(239,128,98)'
            }
            else {
                return 'rgb(255, 24, 24)'
            }
        }

        return 'rgba(38, 124, 204, 0.5)'

    }



    let graph_data = {
        // labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                // label: 'My First Dataset',
                data: data,
                backgroundColor: getBackgroundColor,
                borderColor: getBackgroundColor,
                borderWidth: 1,
            },
        ],
    };

    return <PolarArea data={graph_data} options={options} />

}